import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {RootState} from "@/store/Store";

export interface LaboratoryLegalEntitiesInterface {
    formVisible: boolean,
    formVariant: "new" | "edit",
    editCountryId: number,
    editId: number,
    editInn: string,
    editTitle: string,
    editIsActive: boolean | null,
    deleteStatusModalVisible: boolean,
    deleteId?: string,
}

function getInitialState(): LaboratoryLegalEntitiesInterface {
    return {
        formVisible: false,
        formVariant: "new",
        deleteStatusModalVisible: false,
        editCountryId: -1,
        editId: -1,
        editInn: "",
        editTitle: "",
        editIsActive: null,
    }
}

export const LaboratoryLegalEntitiesSlice = createSlice({
    name: "LaboratoryLegalEntitiesSlice",
    initialState: getInitialState(),
    reducers: {
        changeFormVisibility: (state: LaboratoryLegalEntitiesInterface, action: PayloadAction<boolean>) => {
            state.formVisible = action.payload;
        },
        reset: (state: LaboratoryLegalEntitiesInterface, action: PayloadAction<void>) => {
            const initialState = getInitialState();
            state.formVisible = initialState.formVisible;
            state.formVariant = initialState.formVariant;
            state.deleteStatusModalVisible = initialState.deleteStatusModalVisible;
        },
        changeFormVariant: (state: LaboratoryLegalEntitiesInterface, action: PayloadAction<"new" | "edit">) => {
            state.formVariant = action.payload;
        },
        changeDeleteModalVisibility: (state: LaboratoryLegalEntitiesInterface, action: PayloadAction<boolean>) => {
            state.deleteStatusModalVisible = action.payload;
        },
        changeEditId: (state: LaboratoryLegalEntitiesInterface, action: PayloadAction<number>) => {
            state.editId = action.payload;
        },
        changeEditCountryId: (state: LaboratoryLegalEntitiesInterface, action: PayloadAction<number>) => {
            state.editCountryId = action.payload
        },
        changeEditInn: (state: LaboratoryLegalEntitiesInterface, action: PayloadAction<string>) => {
            state.editInn = action.payload
        },
        changeEditTitle: (state: LaboratoryLegalEntitiesInterface, action: PayloadAction<string>) => {
            state.editTitle = action.payload;
        },
        changeEditIsActive: (state: LaboratoryLegalEntitiesInterface, action: PayloadAction<boolean | null>) => {
            state.editIsActive = action.payload;
        },
        changeDeleteId: (state: LaboratoryLegalEntitiesInterface, action: PayloadAction<string>) => {
            state.deleteId = action.payload;
        },
    },
});

export const {
    changeFormVariant,
    changeFormVisibility,
    changeDeleteModalVisibility,
    changeEditId,
    changeEditCountryId,
    changeEditInn,
    changeEditTitle,
    changeEditIsActive,
    reset,
    changeDeleteId
} = LaboratoryLegalEntitiesSlice.actions;

export const getSelectorForFormVisibility = (state: RootState) => state.laboratoryLegalEntities.formVisible
export const getSelectorForFormVariant = (state: RootState) => state.laboratoryLegalEntities.formVariant;
export const getSelectorForEditId = (state: RootState) => state.laboratoryLegalEntities.editId;
export const getSelectorForEditTitle = (state: RootState) => state.laboratoryLegalEntities.editTitle;
export const getSelectorForEditIsActive = (state: RootState) => state.laboratoryLegalEntities.editIsActive;
export const getSelectorForDeleteModalVisibility = (state: RootState) => state.laboratoryLegalEntities.deleteStatusModalVisible;
export const getSelectorForDeleteId = (state: RootState) => state.laboratoryLegalEntities.deleteId;
export const getSelectorForEditCountryId = (state: RootState) => state.laboratoryLegalEntities.editCountryId;
export const getSelectorForEditInn = (state: RootState) => state.laboratoryLegalEntities.editInn;

export const LaboratoryLegalEntitiesReducer = LaboratoryLegalEntitiesSlice.reducer;
